export default __webpack_public_path__ + "static/media/sexy_bg.341d86ff.png";